import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
// import Perf from 'react-addons-perf';

import DevTools from '../components/Shared/DevTools';
import rootReducer from '../reducers/index.reducer';

const configureStore = initialState => createStore(
  rootReducer,
  initialState,
  compose(
    applyMiddleware(thunk, reduxImmutableStateInvariant()),
    DevTools.instrument()
  )
);

// if (window) {
//   window.Perf = Perf;
// }

export default configureStore;



// WEBPACK FOOTER //
// ./store/config.dev.store.js